<template>
  <div class="plugin-wrapper">
    <div class="plugin-default_plugin layout">
      <div class="heading-h3 text--center">Default Plugin</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DefaultPlugin"
}
</script>

<style lang="scss" scoped>

</style>